/* ty-eilat-price-box: מוסיף לקובייה את «אילת» ו«איסוף עצמי · ללא מע״מ». נטען רק בדפי מוצר אילת.
 * product-info.js מחליף את אזור המחיר בכל החלפת וריאנט, ולכן MutationObserver מחזיר את התווית. */
(function () {
  if (window.__tyEpBox) return; window.__tyEpBox = true;
  function put() {
    var p = document.querySelector('.product__info-container .price');
    if (!p) return;
    if (!p.classList.contains('tyep-on')) p.classList.add('tyep-on');
    if (p.querySelector('.tyep-n')) return;
    var s = document.createElement('span'); s.className = 'tyep-n';
    s.innerHTML = '<b>אילת</b><small>איסוף עצמי · ללא מע״מ</small>';
    p.insertBefore(s, p.firstChild);
  }
  put();
  var box = document.querySelector('.product__info-container');
  if (box) new MutationObserver(put).observe(box, { childList: true, subtree: true });
})();
